import { Category, ICategoryArgs } from "../category/category.model";

export interface IAccessGroupArgs extends ICategoryArgs {
    memberships?: Array<string>;
}

const defaults = {
    memberships: []
} as IAccessGroupArgs;

export class AccessGroup extends Category {
    memberships: Array<string>;

    constructor(data?: IAccessGroupArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.model.ts